import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    border: 2px solid purple;
`

const DayColumnWrapper = (props) => {
    return (
        <Container>
            {props.children}
        </Container>
    )
}

export default DayColumnWrapper